import React from 'react';

const CourseMaterial = ({courseContent}) => {
  // Sample downloadable materials
  const materials = [
    { id: 1, title: "Beauty Clinic Training Manual.pdf", size: "4.2 MB" },
    { id: 2, title: "Skincare Assessment Checklist.pdf", size: "1.8 MB" },
   
  ];

  const handleDownload = (materialId,link) => {
    console.log(`Downloading material with ID: ${materialId}`);
    // In a real app, this would trigger a download
    alert(`Downloading ${materials.find(m => m.id === materialId).title}`);
  };
{
  console.log("courseContent??",courseContent)
}
  return (
    <div className='p-3'>
      <h4 className="mb-4">Downloadable</h4>
      <div className=''>
      {courseContent?.content?.courseMaterials?.map((material,index) => (
        <div key={index} className="download-item">
          <div>
            {/* <i className="bi bi-file-earmark-pdf me-2"></i> */}
            <span className='download-content-title'>{material.title}</span>
            {/* <small className="text-muted ms-2">({material.size})</small> */}
          </div>
         <a
          href={`${process.env.REACT_APP_BUCKET_URL}${material?.materialUrl}`}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm"
        >
          <i className="bi bi-download me-1"></i>
          {/* Download */}
        </a>
        </div>
      ))}
      </div>
     
      
    </div>
  );
};

export default CourseMaterial;